import { useCallback, useContext } from "react";
import { DataContext } from "src/contexts/DataContext";
import { MapContext } from "src/contexts/MapContext";

export const useZoomToAnimal = () => {
  const { data } = useContext(DataContext);
  const { map } = useContext(MapContext);

  const zoomToAnimal = useCallback(() => {
    const dest = {
      center: [
        data[window.sharedState.idx].Long,
        data[window.sharedState.idx].Lat,
      ],
      zoom: 13,
      pitch: 45,
      bearing: 0,
    };
    map.flyTo(dest);
  }, [data, map]);

  return zoomToAnimal;
};